<div class="container-fluid mt-4">
    <div class="row">
        <div class="row form-head">
            <div>
                <a (click)="cancel()" class="ac-goback-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                        <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
                    </svg>
                    Go Back </a>
            </div>
        </div>
        <div class="col-lg-12 mt-3">
            <h2 class="ac-heading">How much do you want to pay?</h2>

            <div class="card">
                <div class="card-body lineheight">

                    <ul class=" list-group mb-3 mt-3">
                        <li class="list-group-item d-flex justify-content-between lh-condensed" style="line-height:30px;">
                            <div>
                                <p class="text-black font-w600 pt-1">Enter Amount</p>
                            </div>
                        </li>
                    
                    </ul>

                    <ul class="list-group mb-3 mt-3 lineheight">
                        <li class="list-group-item d-flex justify-content-around">
                            <span class="ac-mob-lineh" style="margin: 5px 3px 0px 0px;">{{"USD"|
                                currencySymbol}}</span>
                            <input type="number" pattern="/^[0-9]+(\.[0-9]{1,2})?$/" step="any" required name="amount"
                                id="editamount" [(ngModel)]="totalEditedAmount" [value]="totalEditedAmount"
                                onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)"
                                class="inputbox form-control ac-mob-mt"
                                style="height: 30px;text-align: right;margin: 9px 2px;">
                            <br>

                            <span *ngIf="0>=totalEditedAmount"
                                style="color: red;font-size: 9px;position: absolute;top: 39px;">Amount must be greater
                                than 0</span>

                        </li>

                        
                    </ul>
                </div>
                <div class="card-body">
                    <div>
                        <button type="button" class="btn ac-btn-outline-primary ac-butncancel mr-3 "
                            (click)="cancel()">Cancel</button>
                        <button type="button" class="btn ac-btn-primary  mb-sm-0 mb-2"
                            (click)="pay()">Continue</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>